module.exports = __webpack_public_path__ + "static/media/cross.d89c9150.svg";